import { create } from 'zustand';

export const useNotificationStore = create((set, get) => ({
  notifications: [],

  addNotification: (notification) => {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      type: 'info', // 'success', 'error', 'warning', 'info'
      title: '',
      message: '',
      duration: 5000, // Auto-dismiss after 5 seconds
      ...notification,
    };

    set((state) => ({
      notifications: [...state.notifications, newNotification],
    }));

    // Auto-dismiss after duration
    if (newNotification.duration > 0) {
      setTimeout(() => {
        get().removeNotification(id);
      }, newNotification.duration);
    }

    return id;
  },

  /** Change a shown notification in place (a running copy's progress). */
  updateNotification: (id, patch) => {
    set((state) => ({
      notifications: state.notifications.map((n) => (n.id === id ? { ...n, ...patch } : n)),
    }));
  },

  removeNotification: (id) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },

  clearAllNotifications: () => {
    set({ notifications: [] });
  },

  // Convenience methods for different types
  success: (message, title = 'Success') => {
    return get().addNotification({ type: 'success', title, message });
  },

  error: (message, title = 'Error') => {
    return get().addNotification({ type: 'error', title, message, duration: 7000 });
  },

  warning: (message, title = 'Warning') => {
    return get().addNotification({ type: 'warning', title, message });
  },

  info: (message, title = 'Info') => {
    return get().addNotification({ type: 'info', title, message });
  },
}));
